import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCashRegister,
  faChartBar,
  faCartShopping,
  faGear,
  faBox,
  faTable,
  faBowlFood,
  faReceipt,
  faBan,
} from "@fortawesome/free-solid-svg-icons";
import { NavigationLink } from "navigation-react";
import { RoleContext } from "./App";

const DashboardContenLeftMenus = () => {
  // ✅ Use roles from context
  const { roles } = useContext(RoleContext);

  // ✅ Check if user is admin
  const isAdmin = roles?.some(
    (role) => role === "administrator" || role === "admin",
  );

  // ✅ Check if user is cashier
  const isCashier = roles?.some((role) => role === "cashier");

  console.log("roles:", roles);
  console.log("isAdmin:", isAdmin);
  console.log("isCashier:", isCashier);

  return (
    <aside className="sidebar">
      <ul className="menu">
        {/* ✅ DASHBOARD - Everyone can see */}

        <li>
          <NavigationLink stateKey={isAdmin ? "dashboardcontent" : null}>
            <div
              className="menu-circle"
              style={{
                pointerEvents: isAdmin ? "auto" : "none",
                cursor: isAdmin ? "pointer" : "not-allowed",
              }}
            >
              <FontAwesomeIcon
                icon={faChartBar}
                className="menu-icon"
                color={isAdmin ? "#ffffff" : "#6e6767"}
              />
              <span
                className="menu-text"
                style={{
                  color: isAdmin ? "#ffffff" : "#6e6767",
                }}
              >
                Dashboard
              </span>
            </div>
          </NavigationLink>
        </li>

        {/* ✅ ORDERS - Everyone can see (Cashiers need to see orders) */}
        <li>
          <NavigationLink
            stateKey={isAdmin || isCashier ? "orderregister" : null}
          >
            <div
              className="menu-circle"
              style={{
                pointerEvents: isAdmin || isCashier ? "auto" : "none",
                cursor: isAdmin || isCashier ? "pointer" : "not-allowed",
              }}
            >
              <FontAwesomeIcon
                icon={faCartShopping}
                className="menu-icon"
                color={isAdmin || isCashier ? "#ffffff" : "#6e6767"}
              />
              <span
                className="menu-text"
                style={{
                  color: isAdmin || isCashier ? "#ffffff" : "#6e6767",
                }}
              >
                Orders
              </span>
            </div>
          </NavigationLink>
        </li>

        {/* ✅ PAYMENT REGISTER - Everyone can see (Cashiers need to process payments) */}

        <li>
          <NavigationLink stateKey={isAdmin ? "cashregister" : null}>
            <div
              className="menu-circle"
              style={{
                pointerEvents: isAdmin ? "auto" : "none",
                cursor: isAdmin ? "pointer" : "not-allowed",
              }}
            >
              <FontAwesomeIcon
                icon={faCashRegister}
                className="menu-icon"
                color={isAdmin ? "#ffffff" : "#6e6767"}
              />
              <span
                className="menu-text"
                style={{
                  color: isAdmin ? "#ffffff" : "#6e6767",
                }}
              >
                Payment Register
              </span>
            </div>
          </NavigationLink>
        </li>

        {/* ✅ TABLE MANAGER - Only Admin can see */}
        <li>
          <NavigationLink stateKey={isAdmin ? "tablemanager" : null}>
            <div
              className="menu-circle"
              style={{
                pointerEvents: isAdmin ? "auto" : "none",
                cursor: isAdmin ? "pointer" : "not-allowed",
              }}
            >
              <FontAwesomeIcon
                icon={faTable}
                className="menu-icon"
                color={isAdmin ? "#ffffff" : "#6e6767"}
              />
              <span
                className="menu-text"
                style={{
                  color: isAdmin ? "#ffffff" : "#6e6767",
                }}
              >
                Table Manager
              </span>
            </div>
          </NavigationLink>
        </li>

        {/* ✅ MENU - Only Admin can see */}
        <li>
          <NavigationLink stateKey={isAdmin ? "menuregister" : null}>
            <div
              className="menu-circle"
              style={{
                pointerEvents: isAdmin ? "auto" : "none",
                cursor: isAdmin ? "pointer" : "not-allowed",
              }}
            >
              <FontAwesomeIcon
                icon={faBowlFood}
                className="menu-icon"
                color={isAdmin ? "#ffffff" : "#6e6767"}
              />
              <span
                className="menu-text"
                style={{
                  color: isAdmin ? "#ffffff" : "#6e6767",
                }}
              >
                Menu
              </span>
            </div>
          </NavigationLink>
        </li>

        {/* ✅ INVENTORY - Only Admin can see */}
        <li>
          <NavigationLink stateKey={isAdmin ? "inventory" : null}>
            <div
              className="menu-circle"
              style={{
                pointerEvents: isAdmin ? "auto" : "none",
                cursor: isAdmin ? "pointer" : "not-allowed",
              }}
            >
              <FontAwesomeIcon
                icon={faBox}
                className="menu-icon"
                color={isAdmin ? "#ffffff" : "#6e6767"}
              />
              <span
                className="menu-text"
                style={{
                  color: isAdmin ? "#ffffff" : "#6e6767",
                }}
              >
                Inventory
              </span>
            </div>
          </NavigationLink>
        </li>

        {/* ✅ REPORTS - Only Admin can see */}
        <li>
          <NavigationLink stateKey={isAdmin ? "dailyreport" : null}>
            <div
              className="menu-circle"
              style={{
                pointerEvents: isAdmin ? "auto" : "none",
                cursor: isAdmin ? "pointer" : "not-allowed",
              }}
            >
              <FontAwesomeIcon
                icon={faReceipt}
                className="menu-icon"
                color={isAdmin ? "#ffffff" : "#6e6767"}
              />
              <span
                className="menu-text"
                style={{
                  color: isAdmin ? "#ffffff" : "#6e6767",
                }}
              >
                Report
              </span>
            </div>
          </NavigationLink>
        </li>

        {/* ✅ SETTINGS - Only Admin can see */}
        <li>
          <NavigationLink stateKey="">
            <div
              className="menu-circle"
              style={{
                pointerEvents: isAdmin ? "auto" : "none",
                cursor: isAdmin ? "pointer" : "not-allowed",
              }}
            >
              <FontAwesomeIcon
                icon={faGear}
                className="menu-icon"
                color={isAdmin ? "#ffffff" : "#6e6767"}
              />
              <span
                className="menu-text"
                style={{
                  color: isAdmin ? "#ffffff" : "#6e6767",
                }}
              >
                Settings
              </span>
            </div>
          </NavigationLink>
        </li>
      </ul>
    </aside>
  );
};

export default DashboardContenLeftMenus;
